class VideoPlayer {
    constructor(playButton) {
        this.playButton = playButton;
        this.videoContainer = this.playButton.closest('.video-player');
        this.placeholder = this.videoContainer.querySelector('.video-placeholder');
        this.videoId = this.playButton.dataset.videoId; // Utilise data-video-id

        this.addClickListener();
    }

    addClickListener() {
        this.playButton.addEventListener('click', () => this.playVideo());
    }

    playVideo() {
        if (!this.videoId || !this.videoContainer) return;

        // Masquer le bouton et le placeholder
        if (this.placeholder) {
            this.placeholder.style.display = 'none';
        }
        this.playButton.style.display = 'none';

        // Créer l'iframe
        const iframe = document.createElement('iframe');
        iframe.setAttribute('src', `https://www.youtube.com/embed/${this.videoId}?autoplay=1&controls=1&rel=0&showinfo=0`);
        iframe.setAttribute('frameborder', '0');
        iframe.setAttribute('allow', 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture');
        iframe.setAttribute('allowfullscreen', '');
        iframe.setAttribute('title', 'Lecteur vidéo YouTube'); // Ajout d'un titre pour l'accessibilité

        // Ajouter l'iframe au conteneur
        this.videoContainer.appendChild(iframe);
    }
}

export default {
    init() {
        // Sélectionne les boutons avec la nouvelle classe
        const videoButtons = document.querySelectorAll('.video-play-button');
        if (!videoButtons.length) return;

        videoButtons.forEach(button => {
            new VideoPlayer(button);
        });
    }
}